import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const SUBSCRIPTION_HEADER = 'Ocp-Apim-Subscription-Key';

/**
 * Interceptor that adds the app subscription key to API requests.
 * Only adds the header when the request URL matches the configured API base.
 */
export const subscriptionKeyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const serverBaseUrl = environment.apiConfig.serverBaseUrl;
  const subscriptionKey = environment.apiConfig.ocpApimSubscriptionKey;

  const urlMatchesServerBase =
    req.url.startsWith(serverBaseUrl) ||
    req.url.startsWith(serverBaseUrl.replace(/\/$/, ''));

  if (subscriptionKey && urlMatchesServerBase) {
    const cloned = req.clone({
      setHeaders: {
        [SUBSCRIPTION_HEADER]: subscriptionKey,
      },
    });
    return next(cloned);
  }
  return next(req);
};
